import { render, staticRenderFns } from "./LmEditorBuilderUi.vue?vue&type=template&id=a112010c&"
import script from "./LmEditorBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmEditorBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports